import { useEffect } from 'react';
import { useSiteSettings } from '../hooks/useSiteSettings';

interface DocumentTitleProps {
  title?: string;
  suffix?: string;
}

const DocumentTitle: React.FC<DocumentTitleProps> = ({ 
  title, 
  suffix 
}) => {
  const { siteName, loading } = useSiteSettings();

  useEffect(() => {
    if (loading) {
      document.title = 'Loading...';
      return;
    }

    let fullTitle = '';
    
    if (title) {
      fullTitle = title;
      if (suffix) {
        fullTitle += ` - ${suffix}`;
      }
      fullTitle += ` | ${siteName}`;
    } else {
      fullTitle = siteName;
    }

    document.title = fullTitle;
  }, [title, suffix, siteName, loading]);

  return null; // This component doesn't render anything
};

export default DocumentTitle;
